"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinConnectionCommand = exports.DisconnectPinsCommand = exports.ConnectPinsCommand = void 0;
const zod_1 = require("zod");
const net_1 = require("../../net");
const common_1 = require("./common");
/**
 * This command tells us to connect two pins together.
 */
exports.ConnectPinsCommand = zod_1.z.object({
    type: zod_1.z.literal(common_1.CommandType.connectPinsCommand),
    /**
     * The connections that we model aren't isotropic - there is a source and a target.  We are explicitly
     * making a connection FROM one pin TO another.  The source pin is the pin that we are connecting FROM.
     */
    source: net_1.Pin,
    /**
     * The target pin is the pin that we are connecting TO.
     */
    target: net_1.Pin,
});
/**
 * Tells us to disconnect two pins
 *
 * We follow the model in `ConnectPinsCommand`, setting source and pin in
 * this command
 */
exports.DisconnectPinsCommand = zod_1.z.object({
    type: zod_1.z.literal(common_1.CommandType.disconnectPinsCommand),
    source: net_1.Pin,
    target: net_1.Pin,
});
/**
 * A command that can be performed on a document that modifies connections between pins.
 */
exports.PinConnectionCommand = zod_1.z.discriminatedUnion("type", [exports.ConnectPinsCommand, exports.DisconnectPinsCommand]);
//# sourceMappingURL=pinConnection.js.map